import Layout from '@/apps/layout/components'
import CabinetLayout from '@/apps/layout/components/CabinetLayout'
import Profile from '@/apps/Profile'
import React from 'react'

const CabinetProfile = (): React.ReactElement => {
  return (
    <Layout>
      <CabinetLayout>
        <Profile />
      </CabinetLayout>
    </Layout>
  )
}

export default CabinetProfile
